import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

/*
  This route is only be used for unmapped classes
  when there's no associated courses with it
*/
export default store => ({
  // TODO: change this to :class_id once we replace all references
  // keeping this as :course_id because children still consume
  // params.course_id in some places
  path: "class/:course_id",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "classes" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;

      return component;
    })
  ),
  childRoutes: [],
});
